var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotpoints02Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 10L20.5 10M42.5 38L20.5 38M42.5 24L20.5 24M12.5 10C12.5 11.6569 11.1569 13 9.5 13C7.84315 13 6.5 11.6569 6.5 10C6.5 8.34315 7.84315 7 9.5 7C11.1569 7 12.5 8.34315 12.5 10ZM12.5 38C12.5 39.6569 11.1569 41 9.5 41C7.84315 41 6.5 39.6569 6.5 38C6.5 36.3431 7.84315 35 9.5 35C11.1569 35 12.5 36.3431 12.5 38ZM12.5 24C12.5 25.6569 11.1569 27 9.5 27C7.84315 27 6.5 25.6569 6.5 24C6.5 22.3431 7.84315 21 9.5 21C11.1569 21 12.5 22.3431 12.5 24Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotpoints02Dark);
export default __webpack_public_path__ + "static/media/dotpoints-02-dark.a0e74bbaffa0daf07b55517480d9870e.svg";
export { ForwardRef as ReactComponent };